export enum MatchCategory {
  Conflict = "conflict",
  ExactMatch = "exact-match",
  NewPartner = "new-partner",
}
